import { Navigate, type RouteObject } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { LocalLoginPage } from '@/pages/LocalLoginPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { TechnicalAboutPage } from '@/pages/TechnicalAboutPage';
import { AdminUsersPage } from '@/features/admin/AdminUsersPage';
import { NewTranscriptionPage } from '@/features/transcriptions/pages/NewTranscriptionPage';
import { TranscriptionDetailPage } from '@/features/transcriptions/pages/TranscriptionDetailPage';
import { TranscriptionsListPage } from '@/features/transcriptions/pages/TranscriptionsListPage';

export const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/login/local',
    element: <LocalLoginPage />,
  },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/transcriptions" replace /> },
      { path: 'transcriptions', element: <TranscriptionsListPage /> },
      { path: 'transcriptions/new', element: <NewTranscriptionPage /> },
      { path: 'transcriptions/:id', element: <TranscriptionDetailPage /> },
      { path: 'admin/users', element: <AdminUsersPage /> },
      { path: 'about/technical', element: <TechnicalAboutPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
